import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';
import axios from 'utils/axios';
// import { LifeStage } from 'types/models/LifeStage';
import { LifeStageProps } from 'types/props-obj/LifeStageProps';
const initialState: LifeStageProps = {
    apiEndPoint: "lifestage",
    isOpen: false,
    pageNumber:1,
    last_page:1,
    pageLimit:5,
    current_page:1,
    total:0,
    list: [],
    item:null,
    error: null,
    alertPopup: false
  };
const lifestage = createSlice({
    name: 'life-stage',
    initialState,
    reducers: {
      
       
  
      hasError(state, action) {
        state.error = action.payload.error;
      },
      setPageNumber(state, action) {
        state.pageNumber = action.payload;
      },
      setPageLimit(state, action) {
        state.pageLimit = action.payload;
      },
      // get all project list
      getList(state, action) {
        state.list.push(action.payload);
        const replaceList = state.list.filter((liste) => liste.id != 0);
        state.list = replaceList;
      },
  
      // get project details
      setLifeStage(state, action) {
        state.item = action.payload;
      },
  
      // GET LifeStages
      setLifeStagesSuccess(state, action) {
          state.list = action.payload.data;
          state.current_page=action.payload.current_page;
          state.last_page=action.payload.last_page;
          state.total=action.payload.total
      },

    // ADD LifeStage
    addLifeStageSuccess(state, action) {
      state.list = [...state.list,action.payload];      
    },

    // EDIT LifeStage
    editLifeStageSuccess(state, action) {
      var foundIndex = state.list.findIndex(x => x.id == action.payload.id);
      state.list[foundIndex] = action.payload;
    },

    deleteLifeStageSuccess(state, action) {
      const deleteData = state.list.filter((item) => item.id !== action.payload);
      state.list = deleteData;
    }

    }
  });
  export default lifestage.reducer;
  export const {    getList,setPageNumber,setPageLimit} = lifestage.actions;

  export function getLifeStages(params:any={}) {
    return async () => {
      try {
        const response = await axios.get(initialState.apiEndPoint,{params:params});
        dispatch(lifestage.actions.setLifeStagesSuccess(response.data));
      } catch (error) {
        dispatch(lifestage.actions.hasError(error));
      }
    };
  }

  export function getLifeStage(id: string | undefined) {
    return async () => {
      try {
        const response = await axios.post(initialState.apiEndPoint, { id });
        dispatch(lifestage.actions.setLifeStage(response.data));
      } catch (error) {
        dispatch(lifestage.actions.hasError(error));
      }
    };
  }

  export function addLifeStage(ls:any) {
    return async () => {
      try {        
        const response = await axios.post(initialState.apiEndPoint, ls);
        dispatch(lifestage.actions.addLifeStageSuccess(response.data));
      } catch (error) {
        dispatch(lifestage.actions.hasError(error));
      }
    };
  }
  
  export function editLifeStage(id: number | undefined,ls: any) {
    return async () => {
      try {
        const response = await axios.put([initialState.apiEndPoint,  id].join('/'), ls);
        dispatch(lifestage.actions.editLifeStageSuccess(response.data));
      } catch (error) {
        dispatch(lifestage.actions.hasError(error));
      }
    };
  }

  export function deleteLifeStage(id: number | undefined) {
    return async () => {
      try {
        await axios.delete([initialState.apiEndPoint,  id].join('/'));
        dispatch(lifestage.actions.deleteLifeStageSuccess(id));
      } catch (error) {
        dispatch(lifestage.actions.hasError(error));
      }
    };
  }